export default "__VITE_ASSET__adf86700__"